<div class="cams-search-dialog">
    <div class="title d-flex align-items-center justify-content-space-between py-4 bg-gray">
        <h4 class="mb-0">Assign</h4>
        <button class="close-btn bg-transparent p-0 border-none" (click)="close(false)"><i
                class="flaticon-close cursor-pointer"></i></button>
    </div>

    <form [formGroup]="assign_mail_form" (ngSubmit)="assign()">
        <mat-dialog-content class="assign-mail-form">
            <!-- <mat-card class="tagus-card add-user-wrapper">
                <mat-card-content> -->
            <div class="row">
                <div class="col-lg-4">
                    <mat-form-field appearance="outline" class="w-100">
                        <mat-label class="form-label">
                            CAMS ID
                        </mat-label>
                        <input matInput class="form-control" formControlName="applicationId" />
                    </mat-form-field>
                </div>
                <!-- <div class="col-lg-12">
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label class="form-label">
                                Application
                            </mat-label>
                            <mat-select class="form-control">
                                <mat-option *ngFor="let app of application_type" [value]="app.id">
                                    {{app.name}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div> -->
                <div class="col-lg-4">
                    <mat-form-field appearance="outline" class="w-100">
                        <mat-label class="form-label">
                            Primary Status
                        </mat-label>
                        <mat-select class="form-control" formControlName="primaryStatusId"
                            (selectionChange)="primaryStatusChange($event)">
                            <mat-option *ngFor="let primary of primary_status_list" [value]="primary.id">
                                {{primary.primaryStatus}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="col-lg-4">
                    <mat-form-field appearance="outline" class="w-100">
                        <mat-label class="form-label">
                            Secondary Status
                        </mat-label>
                        <mat-select class="form-control" formControlName="secondaryStatusId"
                            (selectionChange)="secondaryStatusChange($event)">
                            <mat-option *ngFor="let secondary of secondary_status_list" [value]="secondary.id">
                                {{secondary.secondaryStatus}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="col-lg-12 mb-30">
                    <mat-slide-toggle formControlName="showAgent">
                        <span class="fw-semibold">Show Agent</span>
                    </mat-slide-toggle>
                </div>


            </div>


            <mat-divider></mat-divider>
            <button mat-flat-button type="button" class="tagus act-btn mt-10" (click)="openCAMSSearchPopup()">
                CAMS Id Quick Search
            </button>
            <div class="mat-elevation-z8 tagus-mat-table mt-10" *ngIf="show_app_table">
                <table mat-table [dataSource]="dataSource" class="assign-camsid-list">

                    <!-- Order ID Column -->
                    <ng-container matColumnDef="camsID">
                        <th mat-header-cell *matHeaderCellDef class="text-start no-whitespace">
                            <!-- <mat-checkbox class="pe-10" 
                                (change)="SelectAllTenant($event)" 
                                [(ngModel)]="select_all"
                                [ngModelOptions]="{ standalone: true }">
                            </mat-checkbox> -->
                            CAMS ID
                        </th>
                        <td mat-cell *matCellDef="let element; index as i" class="fw-semibold text-start">
                            <mat-checkbox class="pe-10" (change)="selectIndividual($event, i)"
                                [(ngModel)]="element.isSelected" [ngModelOptions]="{ standalone: true }">
                            </mat-checkbox>
                            <a target="_blank"
                                [href]="element?.dynamicUrl">
                                {{element.id}}
                            </a>
                        </td>
                    </ng-container>

                    <!-- Store -->
                    <ng-container matColumnDef="store">
                        <th mat-header-cell *matHeaderCellDef class="text-start no-whitespace">Store</th>
                        <td mat-cell *matCellDef="let element" class="text-start">
                            <span> {{element?.store?? '-'}} </span>
                        </td>
                    </ng-container>

                    <!-- Student Name -->
                    <ng-container matColumnDef="studentName">
                        <th mat-header-cell *matHeaderCellDef class="text-start no-whitespace">Student Name</th>
                        <td mat-cell *matCellDef="let element" class="text-start">
                            <!-- {{element?.student?.firstName}}&nbsp;{{element?.student?.lastName}} -->
                            <span class="fw-semibold">{{element?.name ?? '-'}}</span>
                        </td>
                    </ng-container>

                    <!-- Student Name -->
                    <ng-container matColumnDef="courseName">
                        <th mat-header-cell *matHeaderCellDef class="text-start">Course Name</th>
                        <td mat-cell *matCellDef="let element" class="text-start">
                            <span>{{element?.coursesEnrolement?.courseName}}</span>
                        </td>
                    </ng-container>

                    <!-- Student Name -->
                    <ng-container matColumnDef="universityName">
                        <th mat-header-cell *matHeaderCellDef class="text-start">University</th>
                        <td mat-cell *matCellDef="let element" class="text-start">
                            <span>{{element?.coursesEnrolement?.universityName}}</span>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="primaryStatus">
                        <th mat-header-cell *matHeaderCellDef class="text-start no-whitespace">
                            {{ "Primary Status" | translate }}
                        </th>
                        <td mat-cell *matCellDef="let element" class="text-start">
                            <span class="badge fw-medium app-status">
                                {{ element.primaryStatus}}
                            </span>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="secondaryStatus">
                        <th mat-header-cell *matHeaderCellDef class="text-start no-whitespace">
                            {{ "Secondary Status" | translate }}
                        </th>
                        <td mat-cell *matCellDef="let element" class="text-start">
                            <span class="badge fw-medium app-status">
                                {{ element.secondaryStatus}}
                            </span>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                </table>

                <app-global-paginator [length]="pagination_config.total" (globalPageChange)="pagination($event)">
                </app-global-paginator>
            </div>
            <!-- </mat-card-content>
            </mat-card> -->
        </mat-dialog-content>
        <mat-dialog-actions class="border-t-1" align="end">
            <div class="text-end">
                <button type="button" mat-flat-button color="warn" (click)="close(false)">
                    <i class="ri-close-fill"></i> Cancel
                </button>
                <button type="submit" mat-flat-button class="tagus act-btn">
                    <i class="ri-add-fill"></i> Assign
                </button>
                <button type="button" *ngIf="data?.showAssignDone" (click)="assignAndDone(true)" mat-flat-button class="tagus btn-success">
                    <i class="ri-archive-line"></i> Assign & Done
                </button>
            </div>
        </mat-dialog-actions>
    </form>
</div>